import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { testId } from 'ui-components/services/testid-service';
import { Link } from 'react-router-dom';

import style from './style.module.less';
import { messages } from './messages';

const renderProcessingFooter = () => (
  <ModalFooter className={classnames(style.footer, style.processing)}>
    <div className={style['footer-text']} {...testId('processing-footer')}>
      <FormattedMessage {...messages.processingFooter} />
    </div>
    <div className={style['footer-details']}>
      <FormattedMessage {...messages.processingFooterDetails} />
    </div>
  </ModalFooter>
);

const renderCompleteSuccessFooter = (closeModal) => (
  <ModalFooter className={classnames(style.footer, style.complete)}>
    <div className={style['footer-text']} {...testId('complete-footer')}>
      <FormattedMessage {...messages.completeFooter} />
    </div>
    <div className={style['footer-details']}>
      <FormattedMessage
        {...messages.completeFooterDetailStart}
        values={{
          link: (
            <Link onClick={closeModal} to='/shipments/batches/processed'>
              <FormattedMessage {...messages.batchHistory} />
            </Link>
          ),
        }}
      />
    </div>
  </ModalFooter>
);

const renderCompleteWithErrorFooter = () => (
  <ModalFooter className={classnames(style.footer, style['complete-errored'])}>
    <div className={style['footer-text']}>
      <FormattedMessage {...messages.completeErrorFooter} />
    </div>
    <div className={style['footer-details']}>
      <FormattedMessage {...messages.completeErrorFooterDetails} />
    </div>
  </ModalFooter>
);

export const Footer = ({ isProcessing = true, isCompleteSuccess = false, closeModal = noop }) => {
  if (isProcessing) {
    return renderProcessingFooter();
  }
  if (isCompleteSuccess) {
    return renderCompleteSuccessFooter(closeModal);
  }
  return renderCompleteWithErrorFooter();
};

Footer.propTypes = {
  isProcessing: PropTypes.bool,
  isCompleteSuccess: PropTypes.bool,
  closeModal: PropTypes.func,
};
